import { Middleware } from 'redux';

import { Api } from '../../api/api';
import { SdkAction } from '../utils/actions';

const toError = (error: unknown): Error => {
  if (error instanceof Error) return error;
  if (typeof error === 'string' && error.trim()) return new Error(error);
  return new Error('Unexpected request failure');
};

export default function sdkMiddleware(sdk: Api): Middleware {
  return ({ dispatch }) =>
    (next) =>
    (action: SdkAction): unknown => {
      if (!(action.meta && action.meta.apiRequest)) {
        return next(action);
      }

      // eslint-disable-next-line no-param-reassign
      delete action.meta.apiRequest;

      const { callback } = action.payload;

      return callback(sdk, dispatch)
        .then((response: unknown) => response)
        .catch((response: unknown) => Promise.reject(toError(response)));
    };
}
